// We can't use a React context for this without adding alot of complexity to our storyshot tests to ensure
// the app stack context is always present (which we don't ensure today)
let g_isOnSite = false

/**
 * used to determine if we are on-site.  You can prevent code from being included in the on-site compilation
 * by using the "if-not-on-site" removal comments, but sometimes you want to know this even in debug builds,
 * such as when deciding whether to use rem or px sizing (for storyshot purposes).
 * We can't use a React context for this without adding alot of complexity to our storyshot tests to ensure
 * the app stack context is always present (which we don't ensure today)
 * @return {Boolean} - whether we are on-site
 */
export function isOnSite() {
  return g_isOnSite
}

/**
 * used to set that we are on-site.  This is called from the app stack and from the jest config for on-site apps
 */
export function setOnSite() {
  g_isOnSite = true
}

export default isOnSite
